import React, { createContext, useEffect, useState } from 'react';

export const RootContext = createContext();

export const CenterContextProvider = (props) => {
  const SETTING = '_SETTING';
  const getdata = sessionStorage.getItem(SETTING) || false;
  const [allSessionSetting, setAllSessionSetting] = useState(
    getdata && JSON.parse(getdata)
  );

  const [captureSetting, setCaptureSetting] = useState({
    hasStream: false,
  });

  useEffect(() => {
    sessionStorage.setItem(SETTING, JSON.stringify(allSessionSetting));
  }, [allSessionSetting]);

  return (
    <RootContext.Provider
      value={{
        allSessionSetting,
        setAllSessionSetting,
        captureSetting,
        setCaptureSetting,
      }}
    >
      {props.children}
    </RootContext.Provider>
  );
};
